import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=568cb462&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=568cb462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568cb462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568cb462')) {
      api.createRecord('568cb462', component.options)
    } else {
      api.reload('568cb462', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=568cb462&scoped=true&", function () {
      api.rerender('568cb462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fSorv4GTLcBg/JS/comp/GuestBox.vue"
export default component.exports